import { Consent } from 'models';
import { useQuery } from 'query';
import { getConsents } from '../services';
import { getConsentsKey } from './keys';

export const useConsentsQuery = (params: { consentIds?: string[] }) =>
  useQuery<Consent[]>({
    enabled: Boolean(params.consentIds),
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- We missing correct application model in camelCase, we need to fix it
      const response = await getConsents({ consent_ids: params.consentIds });

      return response.data.map((consent) => new Consent(consent));
    },
    queryKey: getConsentsKey({ consentIds: params.consentIds }),
  });
